<template>
    <ul class="categoryList">
        <li class="subCategory" :style="indent">
            <input type="checkbox" :checked="savedCategories.includes(id)" class="parent" @click="checkCategory(id)" />
            <span @click="toggleChildren">
                {{ label }} <span v-if="hasChildren">[{{ showChildren ? '-' : '+' }}]</span>
            </span>
        </li>
        <categoryList
            v-if="showChildren"
            v-for="(node, index) in nodes"
            :key="node.id"
            :nodes="node.children"
            :label="node.name"
            :id="node.id"
            :savedCategories="savedCategories"
            :hasChildren="node.hasChildren"
            @clickedCategory="checkCategory"
            :depth="depth + 1"
        >
        </categoryList>
    </ul>
</template>
<script>
export default {
    props: ['id', 'label', 'nodes', 'depth', 'hasChildren', 'savedCategories'],
    data () {
        return {
            showChildren: !!(this.$route.params.id),
        }
    },
    name: 'categoryList',
    computed: {
        indent () {
            return { transform: `translate(${this.depth * 15}px)` }
        },
    },
    methods: {
        toggleChildren () {
            this.showChildren = !this.showChildren
        },
        checkCategory (id) {
            this.$emit('clickedCategory', id)
        },
    },
}
</script>
<style lang="less">
.container {
    width: 300px;
    margin: 0 auto;
}

.categoryList {
    .label-wrapper {
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid #ccc;

        .has-children {
            cursor: pointer;
        }
    }
}

</style>
